<template>
  <span class="horizontal-resizer border-right border-500 my-1" :class="{'horizontal-resizer-cursor': !resizeDisabled}" @mousedown="onColResizerMouseDown($event)"></span>
</template>
<script>

export default {
  name: "HorizontalResizer",
  props: {
    "data-target-id-to-resize": {
      type: String,
      required: true
    },
    "resizeDisabled": {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
    }
  },
  mounted() {},
  computed: {},
  methods: {
    getElementById: function(targetId) {
      console.log(`[getElementById] targetId = ${targetId}`);
      return document.getElementById(targetId);
    },
    onColResizerMouseDown: function(event) {
      // console.log("[onColResizerMouseDown] event = ", event);

      // event.stopPropagation();
      
      // console.log("[onColResizerMouseDown] this.dataTargetIdToResize = ", this.dataTargetIdToResize);
      const targetElementToResize = this.getElementById(this.dataTargetIdToResize);
      
      if ((this.resizeDisabled === false) && (targetElementToResize !== undefined)) {
        // console.log("[onColResizerMouseDown] targetToResize = ", targetElementToResize);

        const colResizerStartingPointX = event.clientX;
        const styles = window.getComputedStyle(targetElementToResize);
        const colResizerStartWidth = parseInt(styles.width, 10);
        // console.log("[onColResizerMouseDown] colResizerStartingPointX = ", colResizerStartingPointX);
        // console.log("[onColResizerMouseDown] colResizerStartWidth = ", colResizerStartWidth);

        const pauseEvent = function(e) {
          if(e.stopPropagation) e.stopPropagation();
          if(e.preventDefault) e.preventDefault();
          e.cancelBubble=true;
          e.returnValue=false;
          return false;
        }

        const onColResizerMouseMove = function(e) {
          // console.log("[onColResizerMouseDown] -~~-> onColResizerMouseMove");
          
          // e.stopPropagation();
          pauseEvent(e);

          const colResizerTranslation = e.clientX - colResizerStartingPointX;
          //colToResize.style.width = `${colResizerStartWidth + colResizerTranslation}px`;
          targetElementToResize.style.width = `${colResizerStartWidth + colResizerTranslation}px`;
        }

        const onColResizerMouseUp = function(e) {
          // console.log("[onColResizerMouseDown] -~~-> onColResizerMouseUp");

          // e.stopPropagation();
          pauseEvent(e);

          document.body.style.cursor = 'default';
          document.removeEventListener('mousemove', onColResizerMouseMove);
          document.removeEventListener('mouseup', onColResizerMouseUp);
        }

        pauseEvent(event);
        document.body.style.cursor = 'ew-resize';
        document.addEventListener('mousemove', onColResizerMouseMove);
        document.addEventListener('mouseup', onColResizerMouseUp);

      } else {
        console.log("[onColResizerMouseDown] targetElementToResize is undefined ");
      }
    }
  }

};
</script>
<style scoped>

.horizontal-resizer {
  padding-right: 1px;
  padding-left: 2px;
  margin-left: 2px;
}

.horizontal-resizer-cursor {
  cursor: col-resize;
}

</style>